/* Order Tracking — external middleware edition
   Expects a public HTTPS base like: https://sample-middleware.com/api
   Endpoint(s) used:
     GET <BASE>/order-tracking?orderNumber=1234
     GET <BASE>/order-tracking?email=you@example.com
*/

(function () {
  const sections = document.querySelectorAll('[id^="order-tracking-"]');
  if (!sections.length) return;

  // Helper function to detect and normalize On Hold variations (global scope)
  function isOnHoldSubstage(substage) {
    if (!substage || typeof substage !== 'string') return false;
    const normalized = substage.trim().toLowerCase();
    return normalized === 'on hold' || normalized === 'on-hold' || normalized === 'onhold';
  }

  sections.forEach(init);

  function init(root) {
    // Prefer data-endpoint-base on the section element; fallback to hardcoded string
    const ENDPOINT_BASE = (root.dataset.endpointBase || 'https://order-tracking-api.analie.workers.dev/api').replace(/\/$/, '');

    const form = root.querySelector('.ot-form');
    const searchInput = root.querySelector('input[name="search"]');
    const btn = root.querySelector('.ot-btn');
    const errorEl = root.querySelector('.ot-form-error');

    const results = root.querySelector('.ot-results');
    const stageBar = root.querySelector('[data-ot="stage-bar"]');
    const orderNumberEl = root.querySelector('[data-ot="orderNumber"]');
    const customerEmailEl = root.querySelector('[data-ot="customerEmail"]');
    const stageEl = root.querySelector('[data-ot="stage"]');
    const substageEl = root.querySelector('[data-ot="substage"]');
    const trackingWrap = root.querySelector('[data-ot="tracking-wrap"]');
    const trackingLink = root.querySelector('[data-ot="tracking-link"]');
    const showOthersBtn = root.querySelector('[data-ot="show-others"]');
    const othersList = root.querySelector('[data-ot="others-list"]');

    // New enhanced elements
    const currentStatus = root.querySelector('[data-ot="current-status"]');
    const currentStageDisplay = root.querySelector('[data-ot="current-stage-display"]');
    const statusDefinition = root.querySelector('[data-ot="status-definition"]');
    const statusDuration = root.querySelector('[data-ot="status-duration"]');
    const statusShipping = root.querySelector('[data-ot="status-shipping"]');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorEl.hidden = true;

      const searchValue = (searchInput.value || '').trim();
      if (!searchValue) {
        return showError('Enter an order number or email address.');
      }

      // Auto-detect if input is email or order number
      const isEmail = searchValue.includes('@') && searchValue.includes('.');
      const orderNumber = isEmail ? null : searchValue.replace(/^#/, '');
      const email = isEmail ? searchValue.toLowerCase() : null;

      setLoading(true);
      results.hidden = false;

      try {
        const url = new URL(ENDPOINT_BASE + '/order-tracking');
        if (orderNumber) url.searchParams.set('orderNumber', orderNumber);
        else url.searchParams.set('email', email);

        const res = await fetch(url.toString(), { credentials: 'omit' });
        if (!res.ok) {
          const errorData = await res.json().catch(() => ({ error: 'Could not load order information.' }));
          throw new Error(errorData.error || 'Could not load order information.');
        }
        const data = await res.json();

        // Your API returns order details with timeline data
        if (data && data.orderNumber) {
          results.hidden = false;
          hydrateOrder(data);

          // Show progress bars if timeline data exists
          if (data.timeline && data.timeline.stages) {
            renderBars(stageBar, data.timeline);
            updateCurrentStatus(root, data.timeline);
            stageBar.parentElement.style.display = 'block';
          } else {
            // Hide bars if no timeline data
            stageBar.parentElement.style.display = 'none';
          }

          // Hide other orders functionality
          if (showOthersBtn) showOthersBtn.hidden = true;
          if (othersList) othersList.hidden = true;
          return;
        }

        throw new Error('Order not found.');
      } catch (err) {
        results.hidden = true;
        showError(err.message || 'Something went wrong.');
      } finally {
        setLoading(false);
      }
    });


    //james 2/11/26 - tracking url fix
    function extractHref(htmlString) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlString;
      const anchor = tempDiv.querySelector("a");
      return anchor ? anchor.href : htmlString;
    }

    function hydrateOrder(order) {
      // Format order number display based on whether it's a real order number or Salesforce ID
      if (order.orderNumber) {
        if (order.isOrderId) {
          orderNumberEl.textContent = `Order ID: ${order.orderNumber}`;
        } else {
          orderNumberEl.textContent = `#${order.orderNumber}`;
        }
      } else {
        orderNumberEl.textContent = '—';
      }

      customerEmailEl.textContent = order.customerEmail || '—';
      stageEl.textContent = order.stage || '—';
      substageEl.textContent = order.substage || '—';

      // Store substage value on root element for status card (normalize On Hold variations)
      let substageValue = order.substage || order.stage || '—';

      // Debug: Log substage processing (uncomment for debugging)
      // console.log('Processing substage:', { original: order.substage, stage: order.stage, normalized: substageValue });
      if (isOnHoldSubstage(substageValue)) {
        substageValue = 'On Hold'; // Normalize to consistent format
        // console.log('Detected On Hold, normalized to:', substageValue);
      }
      root.substageValue = substageValue;

      //james 2/11/26 tracking url fix
        if (order.trackingUrl && order.trackingNumber) {
          const cleanUrl = extractHref(order.trackingUrl);
          trackingLink.href = cleanUrl;
          trackingLink.textContent = order.trackingNumber;
          trackingWrap.hidden = false;
        } else if (order.trackingNumber) {
          trackingLink.textContent = order.trackingNumber;
          trackingLink.removeAttribute('href');
          trackingWrap.hidden = false;
        } else {
          trackingWrap.hidden = true;
        }

     /* Original Code Backup 
     if (order.trackingUrl && order.trackingNumber) {
        trackingLink.href = order.trackingUrl;
        trackingLink.textContent = order.trackingNumber;
        trackingWrap.hidden = false;
      } else if (order.trackingNumber) {
        trackingLink.textContent = order.trackingNumber;
        trackingLink.removeAttribute('href');
        trackingWrap.hidden = false;
      } else {
        trackingWrap.hidden = true;
      }*/
    }

    function setLoading(v) {
      btn.disabled = v;
      btn.textContent = v ? 'Checking…' : 'Check status';
    }
    function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
  }

  // Helpers (render bars, skeletons, etc.)
  function renderBars(stageBar, timeline) {
    clear(stageBar);

    const rushCheckbox = document.querySelector('[name="rushOrder"]');
    const isRush = rushCheckbox && rushCheckbox.checked;
    /*Rush Order - james - 4/8/2026 */
    const rushDaysConfig = {
        defaultReduction: 10, // subtract # days if rush
        manufReduction: 5,  
        minDays: 1           // never go below 1 day
    };
    /*end*/

    if (!timeline || !timeline.stages) return;

    // Render stage bar (simplified to 5 stages only)
    /*timeline.stages.forEach(stage => {
      const el = seg(stage.stage, stage.status, stage.definition, stage.daysBeforeShipping);
      if (stage.status === 'active') {
        el.setAttribute('aria-current', 'step');
        // Add days to ship badge for active stage
        const badge = document.createElement('small');
        badge.textContent = ` · ${stage.daysBeforeShipping}d to ship`;
        el.appendChild(badge);
      }
      stageBar.appendChild(el);
    });*/

    timeline.stages.forEach(stage => {
    /*Rush Order - james - 4/8/2026 */
    let days2 = stage.daysBeforeShipping;
      if (isRush && days2 > 1) {
         if (stage.stage === 'Manufacturing' /*&& root.substageValue*/) {
          days2 = Math.max(rushDaysConfig.minDays, days2 - rushDaysConfig.manufReduction);
         }else{
          days2 = Math.max(rushDaysConfig.minDays, days2 - rushDaysConfig.defaultReduction);
         }
      }
    /*end*/

      const el = seg(stage.stage, stage.status, stage.definition, stage.daysBeforeShipping);
      if (stage.status === 'active') {
        el.setAttribute('aria-current', 'step');
        // Add days to ship badge for active stage
        const badge = document.createElement('small');
        badge.textContent = ` · ${days2}d to ship`;
        el.appendChild(badge);
      }
      stageBar.appendChild(el);
    });

  }

  function renderOthersList(orders, container, onPick) {
    if (!container) return;
    container.innerHTML = '';
    orders.forEach(o => {
      const card = document.createElement('div');
      card.className = 'ot-card';
      card.innerHTML = `
        <div>#${escapeHtml(o.orderNumber || '')}</div>
        <div>${escapeHtml(o.stage || '—')}${o.substage ? ' • ' + escapeHtml(o.substage) : ''}</div>
        <div>${o.placedAt ? new Date(o.placedAt).toLocaleDateString() : ''}</div>
      `;
      card.addEventListener('click', () => { if (o.orderNumber) onPick(o.orderNumber); });
      container.appendChild(card);
    });
  }

  async function loadByOrderNumber(orderNumber, base, hydrate, stageBar) {
    renderSkeleton(stageBar);
    const url = new URL(base.replace(/\/$/, '') + '/order-tracking');
    url.searchParams.set('orderNumber', orderNumber);
    const res = await fetch(url.toString(), { credentials: 'omit' });
    if (!res.ok) throw new Error('Failed to load selected order.');
    const data = await res.json();
    if (data && data.order) {
      hydrate(data.order);
      renderBars(stageBar, data.order.timeline || []);
    }
  }

  function seg(text, state, definition, daysBeforeShipping) {
    const el = document.createElement('div');
    el.className = `ot-seg ${state}`;
    el.setAttribute('role', 'listitem');

    // Add tooltip with definition if available
    if (definition) {
      el.title = `${definition}${daysBeforeShipping ? `\nDays to ship: ${daysBeforeShipping}` : ''}`;
    }

    const icon = document.createElement('span');
    icon.className = 'ot-check';
    icon.textContent = state === 'done' ? '✓' : state === 'active' ? '⦿' : '•';
    const label = document.createElement('span');
    label.textContent = ` ${text}`;
    el.appendChild(icon); el.appendChild(label);
    return el;
  }
  function renderSkeleton(stageBar) {
    clear(stageBar);
    for (let i = 0; i < 5; i++) stageBar.appendChild(skel(180, 48));
  }
  function skel(w, h) { const el = document.createElement('div'); el.className = 'ot-seg ot-skel'; el.style.width = w+'px'; el.style.height = h+'px'; return el; }
  function clear(node) { while (node.firstChild) node.removeChild(node.firstChild); }
  function daysLeft(startedAt, targetDays) { if (!startedAt || !targetDays) return 0; const s=new Date(startedAt); const d=Math.ceil((Date.now()-s)/86400000); return Math.ceil(targetDays-d); }
  function timingText(o) {
    const di = o.daysInCurrentSubstage, dr = o.daysRemainingInCurrentSubstage;
    if (o.substage && (di != null || dr != null)) {
      if (di != null && dr != null) return `${di}d in "${o.substage}", ~${Math.max(0, dr)}d left`;
      if (dr != null) return `~${Math.max(0, dr)}d left in "${o.substage}"`;
    }
    return 'Updating…';
  }
  function escapeHtml(s){return String(s).replace(/[&<>"']/g,c=>({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));}


  // Get substage descriptions from CSV mapping
  function getSubstageDescriptions() {
    return {
      // Not Started stage substages
      'Preparing:Not Started': "We're setting up your order and lining up each step so everything moves smoothly.",

      // Impression Kit Shipped stage substages
      'Impression Kit Shipped:Not Started': "We're in the pre-ship stage assembling your Impression Kit with all materials and simple step-by-step instructions. You'll receive tracking as soon as it leaves our facility.",
      'Impression Kit Shipped:Impression Kit Shipped': "Your Impression Kit is on the way. Carrier systems can take a few hours to refresh, so it's normal if tracking looks slow at first; we'll keep you posted by email.",

      // Impression Processing stage substages
      'Impression Processing:Impression Kit Received': "We've received your impressions and added them to the review queue. If anything else is needed, we'll let you know; otherwise you can sit back while we get to work.",
      'Impression Processing:Impression Prep': "We're carefully checking your impressions for clarity, depth, and edge detail so they meet Remi standards. 🔍",
      'Impression Processing:Impression QA (Part of Impression Prep)': "We've wrapped the review of your impressions. They're now in the 3D scanning queue, which is the step that creates a precise digital model of your smile.",
      'Impression Processing:Impression QA': "We've wrapped the review of your impressions. They're now in the 3D scanning queue, which is the step that creates a precise digital model of your smile.",
      'Impression Processing:Impression Retrieval': "We're checking your impressions into the lab systems and lining up the next steps. If we need more info, we'll reach out; otherwise we'll keep things moving.",
      'Impression Processing:Awaiting Routing': "We located your impressions and placed them in the 3D scanning queue. You'll hear from us again once scanning begins.",
      'Impression Processing:3D Scanning (Part of awaiting Routing)': "We're turning your impressions into a precise 3D model. This digital model guides the entire build so your final fit matches your teeth closely.",
      'Impression Processing:3D Scanning': "We're turning your impressions into a precise 3D model. This digital model guides the entire build so your final fit matches your teeth closely.",
      'Impression Processing:Awaiting Manufacturing': "Your order is queued for crafting. Our team is preparing materials and scheduling production so there are no delays.",
      'Impression Processing:Bad-Scan Handling': "We noticed a small hiccup in the 3D scan and are fixing it now to keep accuracy high. No action needed from you; we'll update you once it's resolved. 🩵",
      'Impression Processing:Miscellaneous': "We found a tiny snag with your order and are resolving it behind the scenes. If we need more information, we'll contact you; otherwise we'll proceed as soon as it's cleared.",
      'Impression Processing:3D Redo': "We'll need a new impression to continue. We've emailed simple next steps; if you don't see the email, check spam or message us HERE and we'll resend right away.",
      'Impression Processing:Scanning': "We're turning your impressions into a precise 3D model. This digital model guides the entire build so your final fit matches your teeth closely.",
      'Impression Processing:Quality Assurance': "We've wrapped the review of your impressions. They're now in the 3D scanning queue, which is the step that creates a precise digital model of your smile.",

      // Impression Kit Sent stage substages
      'Impression Kit Shipped:Impression Kit Shipped': "Your Impression Kit is on the way. Tracking may be slow to show progress for the first few hours; this is normal and should update soon.",

      // Additional Manufacturing stage substages (common variations)
      'Manufacturing:Quality Assurance': "We're performing a thorough quality check to make sure fit, finish, and details look excellent. If we see anything to perfect, we'll refine it now.",
      'Manufacturing:Quality Control': "We're performing a thorough quality check to make sure fit, finish, and details look excellent. If we see anything to perfect, we'll refine it now.",

      // Additional Shipped stage substages
      'Shipped:Quality Assurance and Shipping': "Your order passed our quality checks and is heading to you. We're excited for you to unbox it. Tracking may take a few hours to refresh, so it's normal if movement looks slow at first. 🩵",
      'Shipped:Quality Control & Shipping': "Your order passed our quality checks and is heading to you. We're excited for you to unbox it. Tracking may take a few hours to refresh, so it's normal if movement looks slow at first. 🩵",

      // 3D Manufacturing / Manufacturing stage substages
      'Manufacturing:Pre Pour-up': "We're preparing your impressions for model building, which is the foundation for the rest of production. This prep helps ensure accuracy later on.",
      'Manufacturing:Pour-up': "We're pouring and setting your impressions into sturdy working models that mirror your teeth closely. No action needed while this cures.",
      'Manufacturing:Popping': "Your solid working models are complete and ready for the next step. Everything remains on schedule.",
      'Manufacturing:Wet Trimming': "We're tidying the edges and rinsing the models so every surface is clean and defined. This helps the final result feel smooth.",
      'Manufacturing:Arch Trimming': "We're refining the model's curves to match the natural shape of your smile. This improves comfort and overall accuracy.",
      'Manufacturing:Prep Tracing': "We're tracing key lines and checking alignment so the final fit follows your teeth precisely. This is a detailed accuracy step.",
      'Manufacturing:Prep Resin': "We're adding a thin smoothing layer in targeted spots to soften edges and boost comfort from day one.",
      'Manufacturing:Model Printing': "Your custom model is being 3D printed with high detail for accuracy. We'll move to inspection as soon as printing finishes.",
      'Manufacturing:3D Printed': "Printing complete. We're prepping the model for inspection, removing supports, and getting it ready for the next checks.",
      'Manufacturing:Model Printing/3D Printed': "Your custom model is being 3D printed with high detail for accuracy. We'll move to inspection as soon as printing finishes.",
      'Manufacturing:Model Inspection': "We're double-checking the model for accuracy, fine details, and smooth edges. If anything needs a touch-up, we'll fix it before moving on.",
      'Manufacturing:Thermoform': "We're forming your custom-fit so it matches your unique smile shape closely. This is where your final piece begins to take form.",
      'Manufacturing:Cutting': "We're trimming the edges for a smooth, comfortable finish. This fine-tuning helps the fit feel natural.",
      'Manufacturing:Polishing': "We're polishing carefully to remove tiny rough spots so your custom-fit sits snug and comfortable.",
      'Manufacturing:Peeling': "We're doing finishing touches for an extra-smooth feel, including a gentle peel and final surface checks.",
      'Manufacturing:QA': "We're performing a thorough quality check to make sure fit, finish, and details look excellent. If we see anything to perfect, we'll refine it now.",

      // Packed and Shipped / Shipped stage substages
      'Shipped:QA & Shipping': "Your order passed our quality checks and is heading to you. We're excited for you to unbox it. Tracking may take a few hours to refresh, so it's normal if movement looks slow at first. 🩵",
      'Shipped:QA and Shipping': "Your order passed our quality checks and is heading to you. We're excited for you to unbox it. Tracking may take a few hours to refresh, so it's normal if movement looks slow at first. 🩵",
      'Shipped:QA & Ship': "Your order passed our quality checks and is heading to you. We're excited for you to unbox it. Tracking may take a few hours to refresh, so it's normal if movement looks slow at first. 🩵",
      'Shipped:QA and Ship': "Your order passed our quality checks and is heading to you. We're excited for you to unbox it. Tracking may take a few hours to refresh, so it's normal if movement looks slow at first. 🩵",

      // On Hold substages for each stage
      'Preparing:On Hold': 'Your order is taking a short pit stop while we verify a few details. This is normal and usually wraps up quickly. We\'ll reach out if we need anything.',
      'Preparing:On-Hold': 'Your order is taking a short pit stop while we verify a few details. This is normal and usually wraps up quickly. We\'ll reach out if we need anything.',
      'Impression Kit Shipped:On Hold': 'Your order is taking a short pit stop while we verify a few details. This is normal and usually wraps up quickly. We\'ll reach out if we need anything.',
      'Impression Kit Shipped:On-Hold': 'Your order is taking a short pit stop while we verify a few details. This is normal and usually wraps up quickly. We\'ll reach out if we need anything.',
      'Impression Processing:On Hold': 'Your order is taking a short pit stop while we verify a few details. This is normal and usually wraps up quickly. We\'ll reach out if we need anything.',
      'Impression Processing:On-Hold': 'Your order is taking a short pit stop while we verify a few details. This is normal and usually wraps up quickly. We\'ll reach out if we need anything.',
      'Manufacturing:On Hold': 'Your order is taking a short pit stop while we verify a few details. This is normal and usually wraps up quickly. We\'ll reach out if we need anything.',
      'Manufacturing:On-Hold': 'Your order is taking a short pit stop while we verify a few details. This is normal and usually wraps up quickly. We\'ll reach out if we need anything.',
      'Shipped:On Hold': 'Your order is taking a short pit stop while we verify a few details. This is normal and usually wraps up quickly. We\'ll reach out if we need anything.',
      'Shipped:On-Hold': 'Your order is taking a short pit stop while we verify a few details. This is normal and usually wraps up quickly. We\'ll reach out if we need anything.'
    };
  }

  // Update current status card with stage data
  function updateCurrentStatus(root, timeline) {
    if (!root) return;

    const currentStatus = root.querySelector('[data-ot="current-status"]');
    const currentSubstageDisplay = root.querySelector('[data-ot="current-substage-display"]');
    const statusDefinition = root.querySelector('[data-ot="status-definition"]');
    const statusShipping = root.querySelector('[data-ot="status-shipping"]');
    const statusDisclaimer = root.querySelector('[data-ot="status-disclaimer"]');

    if (!currentStatus) return;

    const rushCheckbox = document.querySelector('[name="rushOrder"]');
    const isRush = rushCheckbox && rushCheckbox.checked;
    const rushDaysConfig = {
        defaultReduction: 10, // 
        manufReduction: 5,  // 
        minDays: 1           //
    };

    // Check if order is canceled first (all stages are upcoming)
    const isCanceled = timeline.stages.every(s => s.status === 'upcoming');

    if (isCanceled) {
      // Show current status card for canceled orders
      currentStatus.hidden = false;

      // Update substage display to show "Canceled"
      if (currentSubstageDisplay) {
        currentSubstageDisplay.textContent = root.substageValue || 'Canceled';
      }

      // Handle canceled orders
      if (statusDefinition) {
        statusDefinition.innerHTML = 'Your order has been canceled. If this was a mistake, let us know through this <a href="https://shopremi.com/pages/contact-us" target="_blank" rel="noopener" class="ot-form-link">FORM</a> and we\'ll review it as soon as possible.';
      }
      if (statusShipping) {
        // Remove existing classes and add canceled styling
        statusShipping.classList.remove('ot-status-shipped');
        statusShipping.classList.add('ot-status-canceled');
        statusShipping.textContent = 'Order Canceled';
      }
      // Hide disclaimer for canceled orders
      if (statusDisclaimer) statusDisclaimer.hidden = true;
      return; // Exit early for canceled orders
    }

    // Check if order is on hold using robust detection
    const isOnHold = isOnHoldSubstage(root.substageValue);

    if (isOnHold) {
      // Show current status card for on hold orders
      currentStatus.hidden = false;

      // Update substage display to show "On Hold"
      if (currentSubstageDisplay) {
        currentSubstageDisplay.textContent = root.substageValue;
      }

      // Handle on hold orders - get description from mapping based on current stage
      if (statusDefinition) {
        const substageDescriptions = getSubstageDescriptions();
        // Find the active stage to combine with On Hold substage
        const activeStage = timeline.stages.find(s => s.status === 'active');
        const stageKey = activeStage ? `${activeStage.stage}:${root.substageValue}` : root.substageValue;

        // Debug: Log On Hold processing (uncomment for debugging)
        // console.log('On Hold processing:', { activeStage: activeStage?.stage, substage: root.substageValue, stageKey });

        const description = substageDescriptions[stageKey] || 'Your order is taking a short pit stop while we verify a few details. This is normal and usually wraps up quickly. We\'ll reach out if we need anything.';
        statusDefinition.textContent = description;
      }
      if (statusShipping) {
        // Remove existing classes and add on hold styling
        statusShipping.classList.remove('ot-status-shipped', 'ot-status-canceled');
        statusShipping.classList.add('ot-status-on-hold');
        statusShipping.textContent = 'On Hold';
      }
      // Hide disclaimer for on hold orders
      if (statusDisclaimer) statusDisclaimer.hidden = true;
      return; // Exit early for on hold orders
    }

    // Find current active stage for normal orders
    const activeStage = timeline.stages.find(s => s.status === 'active');

    if (activeStage) {
      // Show current status card
      currentStatus.hidden = false;

      // Update substage display from order data
      if (currentSubstageDisplay) {
        // Get substage from the order data that was passed to hydrateOrder
        const substage = root.substageValue || activeStage.stage; // fallback to stage if no substage
        currentSubstageDisplay.textContent = substage;
      }

      // Handle normal orders
      if (statusDefinition) {
        // Get substage-specific description from mapping
        const substageDescriptions = getSubstageDescriptions();
        const substageKey = `${activeStage.stage}:${root.substageValue}`;

        // Debug: Log normal order processing (uncomment for debugging)
        // console.log('Normal order processing:', { stage: activeStage.stage, substage: root.substageValue, stageKey });

        // Check if this might be an undetected On Hold case
        let description = substageDescriptions[substageKey];
        if (!description && isOnHoldSubstage(root.substageValue)) {
          // Fallback for undetected On Hold cases
          description = 'Your order is taking a short pit stop while we verify a few details. This is normal and usually wraps up quickly. We\'ll reach out if we need anything.';
          // console.log('Detected unhandled On Hold case in normal processing');
        } else if (!description) {
          // Standard fallback
          description = activeStage.definition || 'Your order is progressing through our system.';
        }

        statusDefinition.textContent = description;
      }
      if (statusShipping) {
        // Remove any existing special classes
        statusShipping.classList.remove('ot-status-shipped', 'ot-status-canceled', 'ot-status-on-hold');

        // Adjust daysBeforeShipping if rush
        let days = activeStage.daysBeforeShipping;
        if (isRush && days > 1) {
          if (activeStage.stage === 'Manufacturing' /*&& root.substageValue*/) {
            days = Math.max(rushDaysConfig.minDays, days - rushDaysConfig.manufReduction);
          }else{
            days = Math.max(rushDaysConfig.minDays, days - rushDaysConfig.defaultReduction);
          }
        }

        if (days === 0 || !days) {
          statusShipping.textContent = 'Shipped';
          statusShipping.classList.add('ot-status-shipped');
          if (statusDisclaimer) statusDisclaimer.hidden = true;
        } else if (days === 1) {
          statusShipping.textContent = '1 day until shipping';
          if (statusDisclaimer) statusDisclaimer.hidden = false;
        } else {
          statusShipping.textContent = `${days} days until shipping`;
          if (statusDisclaimer) statusDisclaimer.hidden = false;
        }
        
        //old stage
        /*if (activeStage.daysBeforeShipping === 0 || !activeStage.daysBeforeShipping) {
          statusShipping.textContent = 'Shipped';
          statusShipping.classList.add('ot-status-shipped');
          // Hide disclaimer when shipped
          if (statusDisclaimer) statusDisclaimer.hidden = true;
        } else if (activeStage.daysBeforeShipping === 1) {
          statusShipping.textContent = '1 day until shipping';
          // Show disclaimer for shipping estimates
          if (statusDisclaimer) statusDisclaimer.hidden = false;
        } else if (activeStage.daysBeforeShipping) {
          statusShipping.textContent = `${activeStage.daysBeforeShipping} days until shipping`;
          // Show disclaimer for shipping estimates
          if (statusDisclaimer) statusDisclaimer.hidden = false;
        } else {
          statusShipping.textContent = '—';
          // Hide disclaimer when no shipping info
          if (statusDisclaimer) statusDisclaimer.hidden = true;
        }*/
      }
    } else {
      // Hide current status card if no active stage and not canceled
      currentStatus.hidden = true;
    }
  }

  // Mobile responsiveness enhancements
  function enhanceMobileExperience() {
    // Check if we're on mobile
    const isMobile = window.innerWidth <= 768;
    if (!isMobile) return;

    // Find all stage flow containers
    const stageFlows = document.querySelectorAll('.ot-stage-flow');
    const progressBars = document.querySelectorAll('.ot-bar');

    stageFlows.forEach(stageFlow => {
      enhanceScrollableContainer(stageFlow);
    });

    progressBars.forEach(progressBar => {
      enhanceScrollableContainer(progressBar);
    });

    // Touch-friendly enhancements are now handled purely via CSS
    // No DOM reordering needed - elements maintain their original positions
  }

  function enhanceScrollableContainer(container) {
    if (!container) return;

    // Check if content overflows and needs scrolling
    const isOverflowing = container.scrollWidth > container.clientWidth;

    if (isOverflowing) {
      // Add scroll indicators
      addScrollIndicators(container);

      // Add smooth scrolling behavior
      addSmoothScrolling(container);

      // Add touch enhancements
      addTouchEnhancements(container);
    } else {
      // Mark as all visible to hide scroll indicators
      container.classList.add('all-visible');
    }
  }

  function addScrollIndicators(container) {
    // Create invisible scroll indicators that show when content is scrollable
    const indicator = document.createElement('div');
    indicator.className = 'ot-scroll-indicator';
    indicator.style.cssText = `
      position: absolute;
      bottom: -20px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 11px;
      color: var(--ot-muted);
      opacity: 0.6;
      pointer-events: none;
      white-space: nowrap;
    `;
    indicator.textContent = '← Swipe to explore →';

    // Position container relatively if not already
    if (getComputedStyle(container).position === 'static') {
      container.style.position = 'relative';
    }

    container.appendChild(indicator);

    // Hide indicator when scrolled to end
    container.addEventListener('scroll', () => {
      const isAtEnd = container.scrollLeft + container.clientWidth >= container.scrollWidth - 5;
      indicator.style.opacity = isAtEnd ? '0' : '0.6';
    });
  }

  function addSmoothScrolling(container) {
    // Enhance scroll behavior for better UX
    container.style.scrollBehavior = 'smooth';

    // Add momentum scrolling for iOS
    container.style.webkitOverflowScrolling = 'touch';
  }

  function addTouchEnhancements(container) {
    let startX = 0;
    let scrollLeft = 0;
    let isScrolling = false;

    container.addEventListener('touchstart', (e) => {
      startX = e.touches[0].pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
      isScrolling = true;
      container.style.cursor = 'grabbing';
    }, { passive: true });

    container.addEventListener('touchmove', (e) => {
      if (!isScrolling) return;
      e.preventDefault();
      const x = e.touches[0].pageX - container.offsetLeft;
      const walk = (x - startX) * 2; // Scroll speed multiplier
      container.scrollLeft = scrollLeft - walk;
    });

    container.addEventListener('touchend', () => {
      isScrolling = false;
      container.style.cursor = 'grab';
    });
  }

  // Initialize mobile enhancements when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceMobileExperience);
  } else {
    enhanceMobileExperience();
  }

  // Re-run enhancements on window resize
  window.addEventListener('resize', debounce(enhanceMobileExperience, 250));

  // Simple debounce utility
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
})();